import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=819887a4&scoped=true"
import script from "./reset.vue?vue&type=script&lang=js"
export * from "./reset.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=819887a4&prod&lang=less&scoped=true&external"
import style1 from "./reset.vue?vue&type=style&index=1&id=819887a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819887a4",
  null
  
)

export default component.exports